var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ba-loading', { absolute: _vm.absolutePosition, background: _vm.applyBackground }]},[_c('i',{class:`icon loading--${_vm.character}`}),(_vm.showLoadingText)?_c('p',{staticClass:"desc"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('common.' + _vm.loadingText)))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }